import { FlowTypes, MobileDeviceValue } from "@trailhead/smart-setup-core";
import { useRecoilState } from "recoil";
import { 
  DeviceContext,
  newDeviceObNameState,
  oldDeviceObNameState,
  oldDeviceFunctionalState,
  newDeviceActivatedState,
  oldDeviceAccessState,
  deviceFlowTypeState,
  newDeviceIsiPhone14State
} from "./atoms";

export function useDeviceState(): DeviceContext {
  const [newDeviceObName, setNewDeviceObName] = useRecoilState(newDeviceObNameState);
  const [oldDeviceObName, setOldDeviceObName] = useRecoilState(oldDeviceObNameState);
  const [oldDeviceFunctional, setOldDeviceFunctional] = useRecoilState(oldDeviceFunctionalState);
  const [newDeviceActivated, setNewDeviceActivated] = useRecoilState(newDeviceActivatedState);
  const [oldDeviceAccess, setOldDeviceAccess] = useRecoilState(oldDeviceAccessState);
  const [deviceFlowType, setDeviceFlowType] = useRecoilState(deviceFlowTypeState);
  const [newDeviceIsiPhone14, setNewDeviceIsiPhone14] = useRecoilState(newDeviceIsiPhone14State);

  const updateNewDeviceObName = (value: MobileDeviceValue) => {
    setNewDeviceObName(value);
  };
  const updateOldDeviceObName = (value: MobileDeviceValue) => {
    setOldDeviceObName(value);
  };
  const updateOldDeviceFunctional = (value: boolean) => {
    setOldDeviceFunctional(value);
  };
  const updateOldDeviceAccess = (value: boolean) => {
    setOldDeviceAccess(value);
  };

  const updateNewDeviceActivated = (value: boolean) => {
    setNewDeviceActivated(value);
  };

  const updateDeviceFlowType = (value: FlowTypes) => {
    setDeviceFlowType(value);
  };

  const updateNewDeviceIsiPhone14 = (value: boolean) => {
    setNewDeviceIsiPhone14(value);
  };

  // Return the recoil state
  return {
    newDeviceObName, 
    updateNewDeviceObName,
    oldDeviceObName, 
    updateOldDeviceObName,
    oldDeviceFunctional, 
    updateOldDeviceFunctional,
    newDeviceActivated, 
    updateNewDeviceActivated,
    oldDeviceAccess, 
    updateOldDeviceAccess,
    deviceFlowType, 
    updateDeviceFlowType,
    newDeviceIsiPhone14,
    updateNewDeviceIsiPhone14
  };
}
